import { ToastInterface } from 'vue-toastification'

import { MutationParams } from '@/interfaces/mutationParams'

const useCustomMutation = <D, P>(
	toast: ToastInterface,
	mutationType: 'create' | 'update' | 'delete'
): {
	onSuccess: (_: D, variables: MutationParams<P>) => void
	onError: (_: any, variables: MutationParams<P>) => void
} => {
	return {
		onSuccess: (_, variables) => {
			const { raiseToast, onSuccessToast } = variables.config || {}
			raiseToast &&
				toast.success(onSuccessToast || getSuccessMessage(mutationType))
		},
		onError: (errorServer, variables) => {
			const { raiseToast, onErrorToast } = variables.config || {}

			raiseToast &&
				toast.error(
					errorServer?.response?.data?.message ||
						onErrorToast ||
						getErrorMessage(mutationType)
				)
		},
	}
}

const getSuccessMessage = (
	mutationType: 'create' | 'update' | 'delete'
): string => {
	switch (mutationType) {
		case 'create':
			return 'Operación exitosa (Create).'
		case 'update':
			return 'Operación exitosa (Update).'
		case 'delete':
			return 'Operación exitosa (Delete).'
		default:
			return 'Operación exitosa.'
	}
}

const getErrorMessage = (
	mutationType: 'create' | 'update' | 'delete'
): string => {
	switch (mutationType) {
		case 'create':
			return 'Ha ocurrido un error (Create). Por favor, inténtelo de nuevo.'
		case 'update':
			return 'Ha ocurrido un error (Update). Por favor, inténtelo de nuevo.'
		case 'delete':
			return 'Ha ocurrido un error (Delete). Por favor, inténtelo de nuevo.'
		default:
			return 'Ha ocurrido un error. Por favor, inténtelo de nuevo.'
	}
}

export default useCustomMutation
